@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.container {
  align-content: center;
}

.beta-pill {
  margin-left: @space-8;
  padding: 2px @space-8 4px;

  max-height: 24px;

  border-radius: var(--Radius-XL, @space-32);
  border: 1px solid var(--gold-400);
  background-color: var(--gold-200);

  color: var(--default--text-color--17);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: @space-16;
  width: fit-content;
}
